export function isApple(platform: string): boolean {
  return (
    typeof platform === 'string' &&
    ['ios', 'ipados'].includes(platform.toLowerCase())
  );
}
